import LinesTable from "./parts/linesTable";
import Trial from "./parts/trial";
import Urls from "../../api/endpoints";
import { Tabs, Tab } from "react-bootstrap";
import ServiceHistory from "./parts/history";
import Headings from "../../constants/headings";
import React, { useState, useEffect, useCallback } from "react";
import ServiceHistoryTwo from "./parts/historyTwo";
import UserActionHistory from "./parts/userActionHistory";
import CurrentService from "./parts/currentService";
import { NotLogin, Loading, ErrorToast } from "../../shared/index";
import { ErrorHandling, ErrorHandlingAPI } from "../../functions/index";
import { Button } from "react-bootstrap";
import ExtendServiceModal from "./parts/extendServiceModal";
import CancelFreePackageModal from "./parts/cancelFreePackageModal";
import constants from "../../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { InfoToast } from "../../shared/index";
import { cancelFreeIvrPackage, cancelFreeSecretaryPackage } from "../../api/requestAxios/cancelCustomerFreePackage";
function Services(props) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [showCancelFreePackageModal, setShowCancelFreePackageModal] = useState(false);
  const [key, setKey] = useState("ivr");
  const [showExtendIvrSpinner, setShowExtendIvrSpinner] = useState(false);
  const [showExtendSecSpinner, setShowExtendSecSpinner] = useState(false);
  const [showExtendFaxSpinner, setShowExtendFaxSpinner] = useState(false);
  const [cancelFreePackageModalInfo, setCancelFreePackageModalInfo] = useState("");
  const [showCancelIvrSpinner, setShowCancelIvrSpinner] = useState(false);
  const [showCancelSecSpinner, setShowCancelSecSpinner] = useState(false);
  const [showReTestIvrSpinner, setShowReTestIvrSpinner] = useState(false);
  const [showReTestSecSpinner, setShowReTestSecSpinner] = useState(false);

  const setPageData = useCallback(() => {
    fetch(Urls.getSearchedUserPackagesById(props.userId), {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(true);
        if (data.Success) {
          setData(data);
          setLoading(false);
          setShowExtendIvrSpinner(false);
          setShowExtendSecSpinner(false);
          setShowExtendFaxSpinner(false);
          setShowCancelIvrSpinner(false);
          setShowCancelSecSpinner(false);
        } else {
          ErrorHandlingAPI(data);
          setLoading(false);
        }
      })
      .catch((error) => {
        ErrorHandling(error, "services get error", setLoading);
        setLoading(false);
      });
  }, [props.userId, props.token]);

  //#region Extend Service Modal Methods
  const handleClose = (e = null) => {
    if (e) e.preventDefault();
    setShow(false);
  };
  const handleExtendService = (e, durationDays) => {
    e.preventDefault();
    setShow(false);
    switch (key) {
      case "ivr":
        setShowExtendIvrSpinner(true);
        fetch(Urls.extendCustomerIvrPackage(props.userId, durationDays), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + props.token,
          },
          body: JSON.stringify(""),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.Success) {
              setPageData();
              InfoToast(constants.ExtendedSuccess);
            } else {
              ErrorHandlingAPI(data);
              setPageData();
            }
          })
          .catch((error) => {
            setPageData();
            ErrorHandling(error, "extend service error");
          });
        break;
      case "secretary":
        setShowExtendSecSpinner(true);
        fetch(Urls.extendCustomerSecretaryPackage(props.userId, durationDays), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + props.token,
          },
          body: JSON.stringify(""),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.Success) {
              setPageData();
              InfoToast(constants.ExtendedSuccess);
            } else {
              ErrorHandlingAPI(data);
              setPageData();
            }
          })
          .catch((error) => {
            setPageData();
            ErrorHandling(error, "extend service error");
          });
        break;
      case "fax":
        setShowExtendFaxSpinner(true);
        fetch(Urls.extendCustomerFaxPackage(props.userId, durationDays), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + props.token,
          },
          body: JSON.stringify(""),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.Success) {
              setPageData();
              InfoToast(constants.ExtendedSuccess);
            } else {
              ErrorHandlingAPI(data);
              setPageData();
            }
          })
          .catch((error) => {
            setPageData();
            ErrorHandling(error, "extend service error");
          });
        break;
      default:
        break;
    }
  };
  const extendServiceModal = (e, id) => {
    e.preventDefault();
    setShow(true);
  };
  //#endregion

  //#region Cancel Package Modal Methods
  const handleCloseCancelFreePackage = (e = null) => {
    if (e) e.preventDefault();
    setShowCancelFreePackageModal(false);
  };

  const cancelIvrPackage = async () => {
    setShowCancelIvrSpinner(true);
    try {
      const dataIvr = await cancelFreeIvrPackage(props.userId)

      if (dataIvr?.data?.success) {
        setPageData();
        InfoToast(constants.PackageCancelledSuccess);
      } else {
        ErrorHandlingAPI(dataIvr?.data?.errors);
        setPageData();
      }
    }
    catch (error) {
      setShowCancelIvrSpinner(false);
      setPageData();
      ErrorToast(error)
    }

  }


  const cancelSecretaryPackage = async () => {
    setShowCancelSecSpinner(true);
    try {
      const dataSecretary = await cancelFreeSecretaryPackage(props.userId)

      if (dataSecretary?.data?.success) {
        setPageData();
        InfoToast(constants.PackageCancelledSuccess);
      } else {
        ErrorHandlingAPI(dataSecretary?.data?.errors);
        setPageData();
      }
    }
    catch (error) {
      setShowCancelSecSpinner(false);
      setPageData();
      ErrorToast(error)
    }
  }

  const handleCancelFreePackage = (e) => {
    e.preventDefault();

    setShowCancelFreePackageModal(false);
    switch (key) {
      case "ivr":
        cancelIvrPackage()
        break;

      case "secretary":

        cancelSecretaryPackage()

        break;
      default:
        break;
    }
  };
  const cancelFreePackageModal = (e) => {
    e.preventDefault();
    setShowCancelFreePackageModal(true);
    switch (key) {
      case "ivr":
        setCancelFreePackageModalInfo(constants.FreeIvrPackage);
        break;
      case "secretary":
        setCancelFreePackageModalInfo(constants.FreeSecretaryPackage);
        break;
      default:
        break;
    }

  };
  //#endregion

  //#region ReTest Free Package
  const reTestFreeIvrPackage = () => {
    setShowReTestIvrSpinner(true);
    fetch(Urls.reTestFreeIvrPackage(props.userId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
      body: JSON.stringify(""),
    })
      .then((response) => response.json())
      .then((data) => {
        setShowReTestIvrSpinner(false);
        if (data.Success) {
          InfoToast(constants.ReTestFreePackageSuccess);
        } else {
          ErrorHandlingAPI(data);
        }
      })
      .catch((error) => {
        setShowReTestIvrSpinner(false);
        ErrorHandling(error, "reTest ivr package error");
      });
  }
  const reTestFreeSecretaryPackage = () => {
    setShowReTestSecSpinner(true);
    fetch(Urls.reTestFreeSecretaryPackage(props.userId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
      body: JSON.stringify(""),
    })
      .then((response) => response.json())
      .then((data) => {
        setShowReTestSecSpinner(false);
        if (data.Success) {
          InfoToast(constants.ReTestFreePackageSuccess);
        } else {
          ErrorHandlingAPI(data);
        }
      })
      .catch((error) => {
        setShowReTestSecSpinner(false);
        ErrorHandling(error, "reTest secretary package error");
      });
  }
  //#endregion

  useEffect(() => {
    setPageData();
  }, [setPageData]);

  return (
    <main>
      {!props.login ? (
        <NotLogin></NotLogin>
      ) : loading ? (
        <Loading></Loading>
      ) : (
        <>
          <div className="top-margin"></div>
          <div className="services-tabs">
            <Tabs activeKey={key} className="mb-3" onSelect={(k) => setKey(k)}>
              <Tab eventKey="ivr" title={Headings.IVRTabTitle}>
                <div className="user-service-container mb-5">
                  {data &&
                    data.IvrPackageInfo &&
                    data.IvrPackageInfo.History.length ? (
                    <>
                      {data.IvrPackageInfo.CurrentPackageInfo &&
                        (data.IvrPackageInfo.CurrentPackageInfo.Status === 2 ||
                          data.IvrPackageInfo.CurrentPackageInfo.Status === 3) ? (
                        <>
                          {!showExtendIvrSpinner ? (
                            <Button
                              onClick={(e) =>
                                extendServiceModal(e, props.userId)
                              }
                              className="pull-left extend-button"
                            >
                              {constants.ExtendService}
                            </Button>
                          ) : (
                            <Button className="pull-left extend-button">
                              <FontAwesomeIcon icon={faSpinner} spin />
                            </Button>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {data.IvrPackageInfo.CurrentPackageInfo &&
                        data.IvrPackageInfo.CurrentPackageInfo.IsFree ? (
                        <>
                          {!showCancelIvrSpinner ? (
                            <Button
                              onClick={(e) =>
                                cancelFreePackageModal(e, props.userId)
                              }
                              className="pull-left cancel-package-button"
                            >
                              {constants.CancelFreePackage}
                            </Button>
                          ) : (
                            <Button className="pull-left cancel-package-button">
                              <FontAwesomeIcon icon={faSpinner} spin />
                            </Button>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {!showReTestIvrSpinner ? (
                        <Button
                          onClick={(e) =>
                            reTestFreeIvrPackage(props.userId)
                          }
                          className="pull-left re-test-free-package-button"
                        >
                          {constants.ReTestFreePackage}
                        </Button>
                      ) : (
                        <Button className="pull-left re-test-free-package-button">
                          <FontAwesomeIcon icon={faSpinner} spin />
                        </Button>
                      )}
                      <div className="divider"></div>
                      <CurrentService
                        Title={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.CurrentPackageInfo &&
                          data.IvrPackageInfo.CurrentPackageInfo.Title
                        }
                        DurationDays={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.CurrentPackageInfo &&
                          data.IvrPackageInfo.CurrentPackageInfo.DurationDays
                        }
                        Status={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.CurrentPackageInfo &&
                          data.IvrPackageInfo.CurrentPackageInfo.Status
                        }
                        PersianActivationDate={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.CurrentPackageInfo &&
                          data.IvrPackageInfo.CurrentPackageInfo
                            .PersianActivationDate
                        }
                        PersianExpirationDate={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.CurrentPackageInfo &&
                          data.IvrPackageInfo.CurrentPackageInfo
                            .PersianExpirationDate
                        }
                        OperatorNameVisibility={"hidden"}
                      ></CurrentService>
                      <div className="divider"></div>
                      <Trial
                        CurrentPeriodStartDate={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.CurrentPeriodInfo &&
                          data.IvrPackageInfo.CurrentPeriodInfo.PersianStartDate
                        }
                        CurrentPeriodEndDate={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.CurrentPeriodInfo &&
                          data.IvrPackageInfo.CurrentPeriodInfo.PersianEndDate
                        }
                        CurrentPeriodUsageInfo={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.CurrentPeriodInfo &&
                          data.IvrPackageInfo.CurrentPeriodInfo.UsageInfo
                        }
                      ></Trial>
                      <div className="divider"></div>
                      <LinesTable
                        heading={Headings.ServiceLinesTableHeading}
                        data={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.AllRelevantLineNumbers
                        }
                      ></LinesTable>
                      <div className="divider"></div>
                      <ServiceHistoryTwo
                        data={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.History
                        }
                      ></ServiceHistoryTwo>
                      <div className="divider"></div>
                      <UserActionHistory
                        heading={Headings.ServiceUserActionHistoryTableHeading}
                        data={
                          data &&
                          data.IvrPackageInfo &&
                          data.IvrPackageInfo.UserActionHistory
                        }
                      ></UserActionHistory>
                    </>
                  ) : (
                    <h1 className="validation-error text-right mt-5 pt-5">
                      {constants.UserHasNoServicePartOne}&nbsp;
                      {Headings.IVRTabTitle}&nbsp;
                      {constants.UserHasNoServicePartTwo}
                    </h1>
                  )}
                </div>
              </Tab>
              <Tab eventKey="secretary" title={Headings.SecretaryTabTitle}>
                <div className="user-service-container mb-5">
                  {data &&
                    data.SecretaryPackageInfo &&
                    data.SecretaryPackageInfo.History.length ? (
                    <>
                      {data.SecretaryPackageInfo.CurrentPackageInfo &&
                        (data.SecretaryPackageInfo.CurrentPackageInfo.Status ===
                          2 ||
                          data.SecretaryPackageInfo.CurrentPackageInfo.Status ===
                          3) ? (
                        <>
                          {!showExtendSecSpinner ? (
                            <Button
                              onClick={(e) =>
                                extendServiceModal(e, props.userId)
                              }
                              className="pull-left extend-button"
                            >
                              {constants.ExtendService}
                            </Button>
                          ) : (
                            <Button className="pull-left extend-button">
                              <FontAwesomeIcon icon={faSpinner} spin />
                            </Button>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {data.SecretaryPackageInfo.CurrentPackageInfo &&
                        data.SecretaryPackageInfo.CurrentPackageInfo.IsFree ? (
                        <>
                          {!showCancelSecSpinner ? (
                            <Button
                              onClick={(e) =>
                                cancelFreePackageModal(e, props.userId)
                              }
                              className="pull-left cancel-package-button"
                            >
                              {constants.CancelFreePackage}
                            </Button>
                          ) : (
                            <Button className="pull-left cancel-package-button">
                              <FontAwesomeIcon icon={faSpinner} spin />
                            </Button>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {!showReTestSecSpinner ? (
                        <Button
                          onClick={(e) =>
                            reTestFreeSecretaryPackage(props.userId)
                          }
                          className="pull-left re-test-free-package-button"
                        >
                          {constants.ReTestFreePackage}
                        </Button>
                      ) : (
                        <Button className="pull-left re-test-free-package-button">
                          <FontAwesomeIcon icon={faSpinner} spin />
                        </Button>
                      )}
                      <div className="divider"></div>
                      <CurrentService
                        Title={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo.Title
                        }
                        DurationDays={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo
                            .DurationDays
                        }
                        Status={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo.Status
                        }
                        PersianActivationDate={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo
                            .PersianActivationDate
                        }
                        PersianExpirationDate={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo
                            .PersianExpirationDate
                        }
                        OperatorName={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPackageInfo
                            .OperatorName
                        }
                        OperatorNameVisibility={"visible"}
                      ></CurrentService>
                      <div className="divider"></div>
                      <Trial
                        CurrentPeriodStartDate={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPeriodInfo &&
                          data.SecretaryPackageInfo.CurrentPeriodInfo
                            .PersianStartDate
                        }
                        CurrentPeriodEndDate={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPeriodInfo &&
                          data.SecretaryPackageInfo.CurrentPeriodInfo
                            .PersianEndDate
                        }
                        CurrentPeriodUsageInfo={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.CurrentPeriodInfo &&
                          data.SecretaryPackageInfo.CurrentPeriodInfo.UsageInfo
                        }
                      ></Trial>
                      <div className="divider"></div>
                      <LinesTable
                        heading={Headings.ServiceLinesTableHeading}
                        data={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.AllRelevantLineNumbers
                        }
                      ></LinesTable>
                      <div className="divider"></div>
                      <ServiceHistory
                        data={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.History
                        }
                      ></ServiceHistory>
                      <div className="divider"></div>
                      <UserActionHistory
                        heading={Headings.ServiceUserActionHistoryTableHeading}
                        data={
                          data &&
                          data.SecretaryPackageInfo &&
                          data.SecretaryPackageInfo.UserActionHistory
                        }
                      ></UserActionHistory>
                    </>
                  ) : (
                    <h1 className="validation-error text-right mt-5 pt-5">
                      {constants.UserHasNoServicePartOne}&nbsp;
                      {Headings.SecretaryTabTitle}&nbsp;
                      {constants.UserHasNoServicePartTwo}
                    </h1>
                  )}
                </div>
              </Tab>
              <Tab eventKey="fax" title={Headings.FaxTabTitle}>
                <div className="user-service-container mb-5">
                  {data &&
                    data.FaxPackageInfo &&
                    data.FaxPackageInfo.History.length ? (
                    <>
                      {data.FaxPackageInfo.CurrentPackageInfo &&
                        (data.FaxPackageInfo.CurrentPackageInfo.Status === 2 ||
                          data.FaxPackageInfo.CurrentPackageInfo.Status === 3) ? (
                        <>
                          {!showExtendFaxSpinner ? (
                            <Button
                              onClick={(e) =>
                                extendServiceModal(e, props.userId)
                              }
                              className="pull-left extend-button"
                            >
                              {constants.ExtendService}
                            </Button>
                          ) : (
                            <Button className="pull-left extend-button">
                              <FontAwesomeIcon icon={faSpinner} spin />
                            </Button>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      <div className="divider"></div>
                      <CurrentService
                        Title={
                          data &&
                          data.FaxPackageInfo &&
                          data.FaxPackageInfo.CurrentPackageInfo &&
                          data.FaxPackageInfo.CurrentPackageInfo.Title
                        }
                        DurationDays={
                          data &&
                          data.FaxPackageInfo &&
                          data.FaxPackageInfo.CurrentPackageInfo &&
                          data.FaxPackageInfo.CurrentPackageInfo.DurationDays
                        }
                        Status={
                          data &&
                          data.FaxPackageInfo &&
                          data.FaxPackageInfo.CurrentPackageInfo &&
                          data.FaxPackageInfo.CurrentPackageInfo.Status
                        }
                        PersianActivationDate={
                          data &&
                          data.FaxPackageInfo &&
                          data.FaxPackageInfo.CurrentPackageInfo &&
                          data.FaxPackageInfo.CurrentPackageInfo
                            .PersianActivationDate
                        }
                        PersianExpirationDate={
                          data &&
                          data.FaxPackageInfo &&
                          data.FaxPackageInfo.CurrentPackageInfo &&
                          data.FaxPackageInfo.CurrentPackageInfo
                            .PersianExpirationDate
                        }
                        OperatorNameVisibility={"hidden"}
                      ></CurrentService>
                      <div className="divider"></div>
                      <LinesTable
                        heading={Headings.ServiceLinesTableHeading}
                        data={
                          data &&
                          data.FaxPackageInfo &&
                          data.FaxPackageInfo.AllRelevantLineNumbers
                        }
                      ></LinesTable>
                      <div className="divider"></div>
                      <ServiceHistoryTwo
                        data={
                          data &&
                          data.FaxPackageInfo &&
                          data.FaxPackageInfo.History
                        }
                      ></ServiceHistoryTwo>
                      <div className="divider"></div>
                      <UserActionHistory
                        heading={Headings.ServiceUserActionHistoryTableHeading}
                        data={
                          data &&
                          data.FaxPackageInfo &&
                          data.FaxPackageInfo.UserActionHistory
                        }
                      ></UserActionHistory>
                    </>
                  ) : (
                    <h1 className="validation-error text-right mt-5 pt-5">
                      {constants.UserHasNoServicePartOne}&nbsp;
                      {Headings.FaxTabTitle}&nbsp;
                      {constants.UserHasNoServicePartTwo}
                    </h1>
                  )}
                </div>
              </Tab>
            </Tabs>
            <ExtendServiceModal
              show={show}
              handleClose={handleClose}
              handleExtendService={handleExtendService}
            ></ExtendServiceModal>
            <CancelFreePackageModal
              showCancelFreePackageModal={showCancelFreePackageModal}
              handleCloseCancelFreePackage={handleCloseCancelFreePackage}
              handleCancelFreePackage={handleCancelFreePackage}
              info={cancelFreePackageModalInfo}
            ></CancelFreePackageModal>
          </div>
        </>
      )}
    </main>
  );
}
export default Services;
